
import { _replaceAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {},
  "_MAPBOX_CONFIG": {
    "accessToken": "pk.eyJ1IjoidHJveS1yb2JlcnRzb24iLCJhIjoiY2x2bngwbWFsMGhpeTJpdHRndXQ2dHF5diJ9.r51PVYTqq7Qv7R9sdEoaSg"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
